// extracted by mini-css-extract-plugin
module.exports = {"molecule__news-abstract-container":"styles_molecule__news-abstract-container__ChfzT","abstract":"styles_abstract__U5m1K"};